export const subAdminReducer = (
	state = {
		list: undefined,
		count: 0,
		subAdminData: [],
		subAdminDetails: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "SUB_ADMIN_LIST_SUCCESS":
		case "SUB_ADMIN_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				subAdminData: action.payload.subAdminData,
			};
		case "FETCH_SUB_ADMIN_DETAILS":
			return {
				...state,
				subAdminDetails: action.payload,
			};
		case "CLEAR_SUB_ADMIN_DETAILS":
			return {
				...state,
				subAdminDetails: undefined,
			};
		case "SUB_ADMIN_TOGGLE_SUCCESS":
			return {
				...state,
				subAdminDetails: { ...state?.subAdminDetails, isActive: !state?.subAdminDetails?.isActive },
			};
		case "SUB_ADMIN_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
